import React from 'react';

export default function AppFeatures() {
  return (
    <section className='py-5 border-bottom' id='features'>
      <div className='container px-5 my-5'>
        <div className='row gx-5'>
          <div className='col-lg-6 mb-5 mb-lg-0 bg-white'>
            <div className='feature bg-primary bg-gradient text-white rounded-3 mb-3'>
              <i className='bi bi-collection'></i>
            </div>
            <h2 className='h4 fw-bolder'>Machine Capabilities</h2>
            <p>
              <ul>
                <li>CNC Milling &amp; Machining up to 52’ x 25’ x 25’</li>
                <li>Turning up to 16’ in diameter and 22’ in length</li>
                <li>Fourth Axis capabilities</li>
                <li>Welding and Fabrication</li>
                <li>CAD/CAM Solidworks, Mastercam, and Gibbscam</li>
                <li>Flat Grinding</li>
                <li>Sheet Metal bending</li>
                <li>EDM</li>
                <li>Metal Finishing/Plating</li>
              </ul>
            </p>
            {/* <a className='text-decoration-none' href='#!'>
              Call to action
              <i className='bi bi-arrow-right'></i>
            </a> */}
          </div>
          <div className='col-lg-6 mb-5 mb-lg-0 bg-white'>
            <div className='feature bg-primary bg-gradient text-white rounded-3 mb-3'>
              <i className='bi bi-building'></i>
            </div>
            <h2 className='h4 fw-bolder'>Company Data</h2>
            <p>
              <ul>
                <li>Women Owned</li>
                <li>ITAR Certified</li>
                <li>ISO9001/2015 Compliant</li>
                <li>AS9100 Compliant</li>
                <li>DUNS # 081069869</li>
                <li>CAGE CODE 81RD3</li>
              </ul>
            </p>
            {/* <a className='text-decoration-none' href='#!'>
              Call to action
              <i className='bi bi-arrow-right'></i>
            </a> */}
          </div>
        </div>
      </div>
    </section>
  );
}
